<template>
  <div class="grade-managment-topBar">
    <div class="topbar-left-container">
      <!-- 显示年级数量 -->
      <div
        class="grade-count-container"
        v-if="topBarState == 'normal' || topBarState == 'customCreated'"
      >
        <div class="count-text">已创建年级数量:</div>
        <span class="count">{{ gradeCode }}</span>
        <div class="count-text">,班级数量:</div>
        <span class="count">{{ classNumber }}</span>
      </div>
      <!-- 选择学校类型 -->
      <div class="schoole-type-container" v-else-if="topBarState == 'fastCreated'">
        <div class="school-type-choose-guide">请选择学校类型快速生成年级(多选)</div>
        <div class="school-type-checked-container">
          <div class="checked-list">
            <el-checkbox
              v-model="item.checked"
              v-for="(item, index) in schoolTypeCheckedList"
              :key="index"
              @change="chooseSchoolTypeChange"
              >{{ item.typeName }}</el-checkbox
            >
          </div>
          <!-- <div class="checked-confirm">
            <button
              class="confirm-button"
              :disabled="gradeList.length == 0"
              :class="{ disabled: gradeList.length == 0 }"
            >
              生成年级
            </button>
          </div> -->
        </div>
      </div>
    </div>
    <div class="topbar-right-container">
      <div class="operation-container">
        <button
          class="add-custom-button operation-button"
          @click="addCustomgrade"
          v-if="topBarState == 'normal' || topBarState == 'customCreated'"
          v-hasPermi="'sc:grade:add'"
        >
          新增单个年级<i class="iconfont icon-single-created"></i>
        </button>
        <button
          class="add-module-button operation-button"
          @click="showFastModule"
          v-if="topBarState == 'normal'"
          v-hasPermi="'sc:grade:add'"
        >
          快速生成年级<i class="iconfont icon-fast-created"></i>
        </button>
        <button
          class="created-button operation-button"
          v-if="isConfirmCreatedButtonShow"
          @click="confirmCreated"
        >
          确认创建年级<i class="iconfont icon-confirm-created"></i>
        </button>
        <button
          class="cancel-button operation-button"
          @click="cancelCreated"
          v-if="topBarState == 'fastCreated' || topBarState == 'customCreated'"
        >
          取消<i class="iconfont icon-cancel"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topBarState: "normal",
      gradeCode: 0,
      classNumber: 0,
      isConfirmCreatedButtonShow: false,
      gradeList: [],
      schoolTypeCheckedList: [
        {
          checked: false,
          typeName: "小学",
          gradeList: [
            {
              gradeName: "一年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "二年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "三年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "四年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "五年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "六年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
          ],
        },
        {
          checked: false,
          typeName: "初中",
          gradeList: [
            {
              gradeName: "初一年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "初二年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "初三年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
          ],
        },
        {
          checked: false,
          typeName: "高中",
          gradeList: [
            {
              gradeName: "高一年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "高二年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
            {
              gradeName: "高三年级",
              gradeCode: "",
              schoolClassList: [],
              createdMode: "fast",
              isEdit: false,
            },
          ],
        },
      ],
    };
  },
  created() {
    this.$eventBus.$off("setConfirmCreatedButtonShow");
    this.$eventBus.$on("setConfirmCreatedButtonShow", (res) => {
      this.isConfirmCreatedButtonShow = res;
      if (this.topBarState == "customCreated" && !res) {
        this.topBarState = "normal";
      }
    });
    this.$eventBus.$off("updategradeClassNumber");
    this.$eventBus.$on("updategradeClassNumber", (res) => {
      this.gradeCode = res.gradeCode;
      this.classNumber = res.classNumber;
    });
    this.$eventBus.$off("confirmCreatedCallBack");
    this.$eventBus.$on("confirmCreatedCallBack", (res) => {
      this.topBarState = "normal";
    });
  },
  methods: {
    showFastModule() {
      this.topBarState = "fastCreated";
    },
    cancelCreated() {
      this.schoolTypeCheckedList.forEach((item, index) => {
        item.checked = false;
      });
      this.gradeList = [];
      this.topBarState = "normal";
      this.$eventBus.$emit("setNotCreatedgradeList", this.gradeList);
    },
    confirmCreated() {
      this.$eventBus.$emit("confirmCreated");
      // this.$eventBus.$emit("setNotCreatedgradeList",[]);
      // this.isConfirmCreatedButtonShow = false;
      // this.isFastModuleShow = false;
    },
    addCustomgrade() {
      let grade = JSON.parse(
        JSON.stringify({
          gradeName: "",
          gradeCode: "",
          schoolClassList: [],
          isEdit: true,
          createdMode: "custom",
        })
      );
      this.topBarState = "customCreated";
      this.$eventBus.$emit("setNotCreatedgradeList", [grade]);
    },
    chooseSchoolTypeChange() {
      this.gradeList = [];
      this.schoolTypeCheckedList.forEach((item, index) => {
        if (item.checked) {
          this.gradeList.push(...item.gradeList);
        }
      });
      this.gradeList.forEach((item, index) => {
        item.gradeCode = `grade${index + 1}`;
      });
      this.$eventBus.$emit("setNotCreatedgradeList", this.gradeList);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./gradeManagement-topBar.scss";
</style>
